import { AircraftLogEntryEditPage } from './AircraftLogEntryEditPage.tsx';
import { AircraftLogEntryAddPage } from './AircraftLogEntryAddPage.tsx';

export const AircraftLogEntryPage: React.FC<{aircraftId: string, noteId: string}> = ({ aircraftId, noteId }) => {
    if (noteId === 'add') {
        return <AircraftLogEntryAddPage aircraftId={aircraftId} />;
    } else {
        return <AircraftLogEntryEditPage aircraftId={aircraftId} noteId={noteId} />;
    }
};
